import r from "./index945.js";
import a from "./index946.js";
import p from "./index947.js";
import s from "./index948.js";
import i from "./index949.js";
import m from "./index950.js";
function t(o) {
  var e = this.__data__ = new r(o);
  this.size = e.size;
}
t.prototype.clear = a;
t.prototype.delete = p;
t.prototype.get = s;
t.prototype.has = i;
t.prototype.set = m;
export {
  t as default
};
